import React, { useEffect, useState } from "react";
import { HiOutlineChevronRight } from "react-icons/hi";
import { useLocation, Link } from "react-router-dom";

const Breadcrumbs = ({ prevLocation, title, color = "text-primeColor" }) => {
  const location = useLocation();
  const [locationPath, setLocationPath] = useState("");

  useEffect(() => {
    setLocationPath(location.pathname.split("/")[1]);
  }, [location]);

  return (
    <div className="w-full py-6 md:py-8 xl:py-10 flex flex-col gap-2 md:gap-3 transition-all duration-300">
      <h1 className={`text-3xl md:text-4xl xl:text-5xl ${color} font-titleFont font-bold tracking-wide
        transition-all duration-300 hover:opacity-90`}>
        {title}
      </h1>
      <nav className="flex items-center text-sm md:text-base font-normal text-lightText">
        <Link to="/"
          className="hover:text-primeColor transition-colors duration-200">
          {prevLocation === "" ? "Home" : prevLocation}
        </Link>
        {/* <span className="px-2 flex items-center">
          <HiOutlineChevronRight className="text-gray-400" />
        </span> */}
        {/* <span className={`capitalize font-medium ${color} hover:opacity-80 
          transition-all duration-200`}>
          {locationPath}
        </span> */}
      </nav>
    </div>
  );
};

export default Breadcrumbs;
